<template>
    <div>
        <l-map style="width: 100%; height: 600px;" :zoom="zoom" :center="center">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <v-marker-cluster>
              <l-marker 
                  v-for="(marker, idx) in markers"
                  :key="idx"
                  :lat-lng="marker['latlng']"
              >
              <l-popup><a :href="marker['url']">{{marker['title']}}</a></l-popup>
              </l-marker>
          </v-marker-cluster>
        </l-map>
    </div>
</template>

<script>

import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import Leaflet from 'leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

export default {
    name: 'article-map',
    props:['locations'],
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LPopup,
      'v-marker-cluster': Vue2LeafletMarkerCluster
    },
    watch: {
      locations: function (value) {
        this.markers = this.locations_to_marker(value)
      }
    },
    data () {
      return {
        zoom: 6,
        center: [24.683005, 121.771869],
        url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        markers: [[24.413220, 121.819482],[24.423220, 121.829482]],
        text: 'this is a marker'
      }
    },
    created () {
      this.markers = this.locations_to_marker(this.locations)
    },
    methods: {
      locations_to_marker (location_list) {
        let ret = location_list
          .filter(location => {
            if (typeof location === 'undefined' || 
                location === null || 
                typeof location['latitude'] === 'undefined' ||
                typeof location['longitude'] === 'undefined' ||
                isNaN(Number(location['latitude'])) ||
                isNaN(Number(location['longitude']))
            ) {
              return false
            }

            return true
          })
          .map ( location => {
            return {
              latlng: [location['latitude'], location['longitude']],
              url: `/article/${location['system_id']}`,
              title: location['title']
            }
          });

        return ret
      }
    }
  };
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

#mapid { 
  height: 180px; 
}
</style>
